import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ConfigAssetLoaderService,
  InterceptorSkipHeader,
} from '@icullen/api/shared';
import { Observable } from 'rxjs';
import { BannerImage, Banners } from '../../model/banners.model';
import { Widgets } from '../../model/widgets.model';
import { Enquiries } from '../../model/enquiries.model';
import { Consultations } from '../../model/consultations.model';
import { withCache } from '@ngneat/cashew';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MagnoliaApiService {
  API_BASE_URL: string;

  constructor(
    private httpClient: HttpClient,
    configService: ConfigAssetLoaderService
  ) {
    this.API_BASE_URL = configService.getConfig().apiBaseUrl + 'site/';
  }

  getWidgetsByPage(page: string): Observable<Widgets> {
    return this.httpClient.get<Widgets>(
      this.API_BASE_URL + 'widgets?page=' + page,
      {
        ...InterceptorSkipHeader,
        context: withCache({
          version: 'v1',
          key: 'widget-' + page,
        }),
      }
    );
  }

  getHomepageBanners(): Observable<Banners> {
    return this.httpClient
      .get<Banners>(this.API_BASE_URL + 'home/banners', {
        ...InterceptorSkipHeader,
        context: withCache({
          version: 'v1',
          key: 'home-banners',
        }),
      })
      .pipe(map((response: any) => this.mapBanners(response)));
  }

  mapBanners(apiResponse: any): Banners {
    return {
      banners: apiResponse.banners.map((banner: any) => ({
        image: banner.image ? this.mapBannerImage(banner.image) : null,
        link: banner.link,
        mobileImage: banner.mobileImage
          ? this.mapBannerImage(banner.mobileImage)
          : null,
        path: banner.path,
      })),
    };
  }

  mapBannerImage(image: any): BannerImage {
    return {
      link: image['@link'], // Map @link from API to link in the model
      name: image['@name'], // Map @name from API to name in the model
    };
  }

  getEnquiries(service: string): Observable<Enquiries> {
    return this.httpClient.get<Enquiries>(
      this.API_BASE_URL + 'enquiries/' + service,
      InterceptorSkipHeader
    );
  }

  getConsultations(): Observable<Consultations> {
    return this.httpClient.get<Consultations>(
      this.API_BASE_URL + 'consultations',
      InterceptorSkipHeader
    );
  }
}
